import sw from '@uswitch/ev-utils/switch';
import Image from '../../elements/imgix-img';
import ProductTable from './elements';
import { ButtonLink } from '../../elements/button-link';
import { getValue } from './utils';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var formatter = sw({
  'data.Value': function dataValue(_ref) {
    var cell = _ref.cell,
        data = _ref.data;
    return _jsx(ProductTable.data.Value, {
      value: getValue(cell.value, data),
      unit: getValue(cell.unit, data),
      subscript: getValue(cell.subscript, data)
    });
  },
  'data.Auto': function dataAuto(_ref2) {
    var cell = _ref2.cell,
        data = _ref2.data,
        headerImage = _ref2.headerImage;
    return _jsx(ProductTable.data.Auto, {
      text: getValue(cell.text, data),
      headerImage: headerImage
    });
  },
  default: function _default(_ref3) {
    var cell = _ref3.cell;
    return _jsx("div", {
      children: JSON.stringify(cell)
    });
  }
});
var Cell = sw({
  'cells.Split': function cellsSplit(_ref4) {
    var cell = _ref4.cell,
        data = _ref4.data,
        key = _ref4.key,
        headerImage = _ref4.headerImage;
    return _jsx(ProductTable.cells.Split, {
      children: cell.contents.map(function (content, key) {
        return Cell(content.type, {
          cell: content,
          data: data,
          key: key,
          headerImage: headerImage
        });
      }, this)
    }, key);
  },
  'cells.Image': function cellsImage(_ref5) {
    var cell = _ref5.cell,
        data = _ref5.data,
        key = _ref5.key,
        headerImage = _ref5.headerImage;
    return _jsx(ProductTable.cells.Image, {
      headerImage: headerImage,
      children: _jsx(Image, {
        src: getValue(cell.image, data),
        alt: getValue(cell.alt, data),
        width: "223px"
      })
    }, key);
  },
  'cells.Cta': function cellsCta(_ref6) {
    var cell = _ref6.cell,
        data = _ref6.data,
        key = _ref6.key,
        headerImage = _ref6.headerImage;
    var secondaryText = getValue(cell.secondary.text, data);
    var secondaryImage = getValue(cell.secondary.image, data);
    return _jsx(ProductTable.cells.Cta, {
      primary: _jsx(ButtonLink, {
        variant: "primary",
        href: getValue(cell.primary.href, data),
        target: "_blank",
        children: getValue(cell.primary.text, data)
      }),
      secondary: secondaryText || secondaryImage ? _jsxs("div", {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        },
        children: [secondaryText ? _jsx(ButtonLink, {
          variant: "link",
          href: getValue(cell.secondary.href, data),
          target: "_blank",
          children: secondaryText
        }) : null, secondaryImage ? _jsx(Image, {
          src: secondaryImage,
          alt: getValue(cell.secondary.imageAlt, data),
          height: 75
        }) : null]
      }) : null,
      headerImage: headerImage
    }, key);
  },
  'cells.Content': function cellsContent(_ref7) {
    var cell = _ref7.cell,
        data = _ref7.data,
        key = _ref7.key,
        headerImage = _ref7.headerImage;
    var label = formatter(cell.label.type, {
      cell: cell.label,
      data: data
    });
    return _jsx(ProductTable.cells.Content, {
      label: label,
      accent: getValue(cell.accent, data) || false,
      headerImage: headerImage,
      children: formatter(cell.content.type, {
        cell: cell.content,
        data: data,
        headerImage: headerImage
      })
    }, key);
  },
  default: function _default(_ref8) {
    var cell = _ref8.cell,
        key = _ref8.key;
    return _jsx("div", {
      children: JSON.stringify(cell)
    }, key);
  }
});
export default Cell;
//# sourceMappingURL=cell.js.map